import { render, staticRenderFns } from "./QuickCreateGroup.vue?vue&type=template&id=5b7ad905&scoped=true"
import script from "./QuickCreateGroup.vue?vue&type=script&lang=js"
export * from "./QuickCreateGroup.vue?vue&type=script&lang=js"
import style0 from "./QuickCreateGroup.vue?vue&type=style&index=0&id=5b7ad905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7ad905",
  null
  
)

export default component.exports